<template>
  <div v-if="isShowSearch" style="height:100%" class="yxtbiz-select-catelog">
    <yxt-input
      v-if="isShowSearch"
      v-model="catalogName"
      :placeholder='$t("pc_biz_kng_lbl_search_category_name"/* 搜索分类名称 */)'
      maxlength="20"
      searchable
      @search="searchCatalog"
    />
    <yxt-tree 
      class="select-kng-catalog__calc-height mt16"
      ref="kngTree"
      v-loading="treeLoading"
      :data="kngTreeData"
      :props="defaultProps"
      :wrap-width="wrapWidth"
      :current-node-key="currentId"
      node-key="id"
      @node-click="nodeClick"
      @current-change="currentNodeChange"
      :filter-node-method="filterCatalogNode"
      :default-checked-keys="checkLists"
      :default-expanded-keys="expandCatalog"
      :check-strictly="checkStrictly"
      :highlight-current="!isNeedCheck"
      :show-checkbox="isNeedCheck">
    </yxt-tree>
  </div>
  <yxt-tree
    v-else
    class="select-kng-catalog mt16"
    ref="kngTree"
    v-loading="treeLoading"
    :data="kngTreeData"
    :props="defaultProps"
    :wrap-width="wrapWidth"
    :current-node-key="currentId"
    node-key="id"
    @node-click="nodeClick"
    @current-change="currentNodeChange"
    :filter-node-method="filterCatalogNode"
    :default-checked-keys="checkLists"
    :default-expanded-keys="expandCatalog"
    :check-strictly="checkStrictly"
    :highlight-current="!isNeedCheck"
    :show-checkbox="isNeedCheck">
  </yxt-tree>
</template>

<script>
import api from './service';
import {enmuFunctions} from '../../function-points';
import commonUtil from '../../common-util';

import {
  Tree
} from 'yxt-pc';
export default {
  name: 'YxtbizSelectKngCatalog',
  components: {
    YxtTree: Tree
  },
  props: {
    // 学院ID 如果不传获取全部的目录
    collegeId: String,
    // 选中某个节点并展开父节点 优先级高
    currentCategoryId: String,
    // 选中首个节点 优先级低，复选框开启后这个属性失效
    currentFirstNode: {
      type: Boolean,
      default: false
    },
    // 根（学院级目录）目录是否可选，
    rootCanCheck: {
      type: Boolean,
      default: false
    },
    // 根目录是否可以通过点击选中
    rootCanSelect: {
      type: Boolean,
      default: false
    },
    wrapWidth: {
      type: [String, Number],
      default: 320
    },
    checkLists: {
      type: Array,
      default: () => []
    },
    isNeedCheck: {
      type: Boolean,
      default: true
    },
    checkId: {
      type: String,
      default: ''
    },
    checkStrictly: {
      type: Boolean,
      default: true
    },
    isExpandCatalog: {
      type: Boolean,
      default: false
    },
    pmType: {
      type: Number,
      default: 0
    },
    isShowDisabledCollege: {
      type: Boolean,
      default: false
    },
    // 是否显示搜索框
    isShowSearch: {
      type: Boolean,
      default: false
    },
    // 来源，目前只有te
    sourceType: String,
    filterClosedCollegeData: { // 是否过滤未开启的课堂的目录
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      treeLoading: true, // loading-tree
      kngTreeData: [], // 目录树的数据
      defaultProps: {
        children: 'children', // 默认子集的字段
        label: 'label', // 默认标题的字段
        nocheck: this.nocheckFilter
      },
      singleTree: {},
      // 不可选的列表 用于过滤不可点击
      nocheckList: [],
      // 需要展开节点的列表
      expandCatalog: [],
      catalogName: '',
      currentId: ''
    };
  },
  watch: {
    collegeId: {
      handler() {
        this.getCatalogInfo();
      },
      immediate: true
    }
  },
  methods: {
    // 获取知识库目录
    async getCatalogInfo() {
      this.treeLoading = true;
      let request = {
        pmType: this.pmType,
        filter: this.filterClosedCollegeData ? 1 : 0
      };
      if (this.collegeId) {
        request.collegeId = this.collegeId;
      }
      try {
        await commonUtil.preCheckFunctions(enmuFunctions);
        let res = await api.getKngTreeNew(request);
        if (res && res.length) {
          const val = commonUtil.checkTimeOutFnc(enmuFunctions.ONLINE_ClASS_SELECT_CATALOG);
          // 如果未增购企课堂，只显示主学院，如果传参要求显示禁用课堂就不再过滤
          if (val !== undefined && !(val >= 2 && val <= 4) && !this.isShowDisabledCollege) {
            res = res.filter(item => {
              return item.mainCollege;
            });
          }
          this.kngTreeData = res;
          if (this.isExpandCatalog) {
            // 展开第一层目录
            res.forEach(item => {
              this.expandCatalog.push(item.id);
            });
          }
          // 如果要选中第一个学院
          if (this.currentFirstNode && !this.isNeedCheck) {
            // 取出第一个节点id设置选中
            this.$nextTick(() => {
              this.$refs.kngTree && this.$refs.kngTree.setCurrentKey(res[0].id);
              this.currentNodeChange(res[0]);
            });
            // 不展开任何目录
            this.expandCatalog = [];
          }
          // 如果传了选中节点
          if (this.currentCategoryId) {
            this.$nextTick(()=>{
              this.$refs.kngTree && this.$refs.kngTree.setCurrentKey(this.currentCategoryId);
              if (this.$refs.kngTree) {
                let node = this.$refs.kngTree.getNode(this.currentCategoryId);
                // 展开选中节点的父级节点
                this.expandCatalog = [node.data.parentId];
              }
            });
          } else if (this.collegeId && this.sourceType === 'te') { // 如果传了collegeId 而且是讲师那边调用的
            let item = res.length && res[0];
            item = item.children && item.children.length && item.children[0];
            let currentId = item && item.id;
            if (currentId) {
              this.$nextTick(() => {
                this.$refs.kngTree.setCurrentKey(currentId);
                this.expandCatalog = [item.parentId];
              });
            }
          }
          // 如果显示复选框的情况下，默认不可选根目录
          if (this.isNeedCheck && !this.rootCanCheck || !this.isNeedCheck && !this.rootCanSelect) {
            res.forEach(item => {
              this.nocheckList.push(item.id);
            });
          }
          // 单选时设置选中项
          if (!this.isNeedCheck && this.checkId.length > 0) {
            this.$nextTick(() => {
              this.$refs.kngTree.setCurrentKey(this.checkId);
              this.singleTree = this.$refs.kngTree.getCurrentNode();
            });
          }
          this.treeLoading = false;
        }
      } catch (err) {
        this.treeLoading = false;
        console.log(err);
      }
    },
    // 单击目录时的选择
    nodeClick(item) {
      // 如果选择了一级目录 取消选中
      if (this.nocheckList.includes(item.id)) {
        this.$refs.kngTree.setCurrentKey(null);
        return false;
      }
      this.singleTree = item;
      this.$emit('click-node', item.id, item);
    },
    // 获取选中树数据id
    getCheckTree() {
      if (this.isNeedCheck) {
        if (this.$refs.kngTree) {
          let treeLists = this.$refs.kngTree.getCheckedNodes();
          let tempLists = [];
          treeLists.map(item => {
            let obj = {
              label: item.label,
              id: item.id
            };
            tempLists.push(obj);
          });
          return tempLists;
        }
        return [];
      } else {
        return this.singleTree;
      }
    },
    // 检查节点是否显示复选框
    nocheckFilter(data) {
      return this.nocheckList.includes(data.id);
    },
    // 搜索框触发事件
    searchCatalog(value) {
      this.$refs.kngTree && this.$refs.kngTree.filter(value);
    },
    // 根据分类名称过滤分类树
    filterCatalogNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 选中指定节点
    setCurrentNode(categoryId) {
      if (categoryId) {
        this.$nextTick(() => {
          this.$refs.kngTree.setCurrentKey(categoryId);
        });
      }
    },
    // 选择节点变更
    currentNodeChange(data) {
      this.$emit('current-node-change', data.id, data);
    },
    // 获得选中节点
    getCurrentNode() {
      return this.$refs.kngTree.getCurrentNode();
    }
  }
};
</script>
